<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="2"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">预订设置</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="联系人信息">
              <LinkmanItem ref="linkMan" :contractMessage="ruleForm.teamContractInfo"
                           :requiredList="ruleForm.teamMustContractInfo"
                           @change="changeLinkMan"
              ></LinkmanItem>
            </a-form-model-item>
            <a-form-model-item label="游客信息">
              <TouristItem :isPlayName="ruleForm.teamNeedTourist" :catalogId="Number(catalogId)"
                           :optionTouristSelct="ruleForm.teamTouristZjType"
                           @change="getIsPlayName" @selectChange="getSelectTourist"
              ></TouristItem>
            </a-form-model-item>
            <a-form-model-item required label="提前预订" class="mb0">
              <a-form-model-item class="inline mr15" prop="teamBookingDay">
                <a-input v-model.number="ruleForm.teamBookingDay" placeholder="请输入" addon-before="请在出团前的"
                         suffix="天的"/>
              </a-form-model-item>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <a-form-model-item class="inline" prop="teamBookingTime">
                <a-input v-model.number="ruleForm.teamBookingTime" placeholder="请输入" suffix="点前预订"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="分批退款" prop="teamCancelRules">
              <a-radio-group v-model="ruleForm.teamCancelRules">
                <a-radio :value="0">不支持退款</a-radio>
                <a-radio :value="1">支持部分退款</a-radio>
                <a-radio :value="2">只能整单退款</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="订单取消时间" prop="teamOrderCancelTime">
              <a-select v-model="ruleForm.teamOrderCancelTime" allowClear placeholder="请选择" style="max-width:300px;">
                <a-select-option v-for="item in orderCancelTimeList" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <span>&nbsp;线路类产品，未支付默认24小时自动取消</span>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <a-button v-if="isShow" @click="onNext" style="margin-left: 20px">下一步</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '@/views/product/productGroup/components/ProductHeader'
import PublishHelper from '@/views/product/productGroup/components/PublishHelper'
import TouristItem from '../components/TouristItem'
import LinkmanItem from '../components/LinkmanItem'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'PresaleSetting',
  components: {
    ProductHeader,
    PublishHelper,
    TouristItem,
    LinkmanItem
  },
  mixins: [ruleFormMixins],
  props: {},
  data() {
    return {
      submitLoading: false,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      isShow: false,
      ruleForm: {
        teamBookingDay: '',//提前预定天数
        teamBookingTime: '',// 提前预定时间
        teamCancelRules: 0,//退改规则 0不支持退款 1部分退 2整单退
        teamContractInfo: '',//联系人信息
        teamMustContractInfo: '',//联系人信息必填项 ,
        teamNeedTourist: 2,//是否需要游客信息 0不需要 1仅需一人 2需所有
        teamOrderCancelTime: 24,//订单取消时间(小时)
        teamTouristZjType: []//游客需证件类型
      },
      orderCancelTimeList: [
        { value: 0.5, label: '30分钟' },
        { value: 3, label: '3小时' },
        { value: 9, label: '9小时' },
        { value: 24, label: '24小时' }
      ],
      rules: {
        teamBookingDay: [
          { required: true, message: '请输入天数', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的天数', trigger: 'blur' }
        ],
        teamBookingTime: [
          { required: true, message: '请输入时间', trigger: 'blur' },
          { pattern: /^([0-9]|(1[0-9])|(2[0-3]))$/, message: '请输入正确的时间1-23', trigger: 'blur' }
        ],
        teamCancelRules: [
          { required: true, message: '请选择退款规则', trigger: 'change' }
        ],
        teamOrderCancelTime: [
          { required: true, message: '订单取消时间', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.getProTeamBookingSetting()
  },
  methods: {
    getIsPlayName(data) {
      this.getLogUtils().logWithTag('getIsPlayName', data)
      this.ruleForm.teamNeedTourist = data
    },
    getSelectTourist(data) {
      this.getLogUtils().logWithTag('getSelectTourist', data)
      this.ruleForm.teamTouristZjType = data
    },
    changeLinkMan(data) {
      this.getLogUtils().logWithTag('changeLinkMan', data)
      this.ruleForm.teamContractInfo = data.str
      this.ruleForm.teamMustContractInfo = data.requiredStr
    },
    checkForm() {
      if (this.ruleForm.teamNeedTourist != 0) {
        const filterList = this.ruleForm.teamTouristZjType.filter(id => String(id) !== '10')
        if (!filterList || filterList.length < 1) {
          this.$message.error('请选择游客信息证件')
          return false
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.proId = this.proId
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.submitFormData.teamTouristZjType = this.submitFormData.teamTouristZjType.join(',')
      this.getHttpServices().getProService().post('product/team/addOrUpdateProTeamBookingSetting', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('预订设置成功')
        setTimeout(() => {
          this.onNext()
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onNext() {
      this.$router.push({
        name: 'OptionList',
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    },
    getProTeamBookingSetting() {
      this.getHttpServices().getProService().post('product/team/getProTeamBookingSetting/' + this.proId).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm = res
        this.ruleForm.teamTouristZjType = res.teamTouristZjType && String(res.teamTouristZjType).trim().length > 0 ? res.teamTouristZjType.split(',') : ['1', '10']
        this.$refs.linkMan.getLinkInfo(this.ruleForm.teamContractInfo, this.ruleForm.teamMustContractInfo)
        if (res.teamBookingTime) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped lang="less">
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;

      .inline {
        display: inline-block;
      }

      .ml15 {
        margin-left: 15px;
      }

      .mr15 {
        margin-right: 5px;
      }

      .mb0 {
        margin-bottom: 0;
      }
    }
  }
}
</style>